import { cn } from '../../../lib';

type RadioToggleOption = {
  value: string;
  label: string;
};

type RadioToggleProps = {
  options: RadioToggleOption[];
  value: string | undefined;
  onChange: (value: string) => void;
  disabled?: boolean;
  name?: string;
};

export const RadioToggle = ({ options, value, onChange, disabled, name }: RadioToggleProps) => {
  return (
    <div
      role="radiogroup"
      aria-label={name}
      className={cn(
        'inline-flex self-start h-10 rounded-full border border-input bg-background p-1 shadow-sm',
        disabled && 'cursor-not-allowed opacity-95',
      )}
    >
      {options.map(option => {
        const isSelected = option.value === value;
        return (
          <button
            key={option.value}
            type="button"
            role="radio"
            aria-checked={isSelected}
            disabled={disabled}
            onClick={() => onChange(option.value)}
            className={cn(
              'flex cursor-pointer items-center justify-center rounded-full px-6 text-sm transition-all duration-200',
              isSelected
                ? 'bg-primary text-primary-foreground shadow-sm'
                : 'text-muted-foreground hover:text-foreground',
              'disabled:cursor-not-allowed',
            )}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
};
